var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "news container html-content" },
    [
      _c("h1", { staticClass: "news-title" }, [
        _vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")
      ]),
      _c(
        "div",
        { staticClass: "news-filter" },
        [
          _c("ui-segmented", {
            staticClass: "news-filter-segmented",
            attrs: { labels: ["Все", "Новости", "Акции"] },
            model: {
              value: _vm.typeName,
              callback: function($$v) {
                _vm.typeName = $$v
              },
              expression: "typeName"
            }
          }),
          _c("ui-select", {
            staticClass: "news-filter-select",
            attrs: { options: _vm.computedSpecs },
            on: { change: _vm.updatePublications },
            model: {
              value: _vm.periodName,
              callback: function($$v) {
                _vm.periodName = $$v
              },
              expression: "periodName"
            }
          })
        ],
        1
      ),
      _vm.filteredPublications.length
        ? _c(
            "div",
            { staticClass: "news-publications" },
            _vm._l(_vm.filteredPublications, function(publication) {
              return _c("publication-card", {
                key: publication.id,
                attrs: { info: publication },
                nativeOn: {
                  click: function($event) {
                    return _vm.openPublication(publication.id)
                  }
                }
              })
            }),
            1
          )
        : _c("page-info", { attrs: { title: "Публикации не найдены" } }, [
            _vm._v("\n    Попробуйте поискать по другим разделам или\n    "),
            _c("span", { on: { click: _vm.resetFilter } }, [
              _vm._v("сбросить фильтры")
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }